import { formatAppVersionLabel } from '@/config/appInfo'

export function SidebarAppFooter({ productLabel }: { productLabel: string }) {
  return (
    <div className="px-2 py-1 font-mono text-xs text-fg-muted">
      {productLabel}
      <br />
      Ramme Tech © {new Date().getFullYear()}
      <br />
      {formatAppVersionLabel()}
    </div>
  )
}
